import { IconButton, IconButtonProps, styled, useTheme } from "@mui/material";

const StyledSquareIconButton = styled(IconButton)<IconButtonProps>(
  ({ theme, disabled }) => ({
    color: disabled ? theme.palette.gray.dark : "black",
    backgroundColor: disabled
      ? theme.palette.disabled.dark
      : theme.palette.gray.dark,
    borderRadius: "10px",
    ":hover": {
      backgroundColor: theme.palette.darkGray.light
    }
  })
);

/**
 * A button that renders a rounded square border around an icon.
 */
export const SquareIconButton = (props: IconButtonProps) => {
  const theme = useTheme();
  return (
    <StyledSquareIconButton
      sx={{
        "&.Mui-disabled": {
          backgroundColor: theme.palette.disabled.main
        }
      }}
      {...props}
    />
  );
};
